@if (message()) {
    <!-- Built like the theme and account sections beside it; amber marks it as the way out. -->
    <button
        type="button"
        class="flex cursor-pointer items-center gap-2.5 rounded-xl border border-[var(--p-amber-400)]/30 px-2 pb-[6px] pt-[5px] transition-all duration-200 hover:border-[var(--p-amber-400)]/60 hover:bg-[var(--p-amber-400)]/10"
        [pTooltip]="message()"
        tooltipPosition="bottom"
        [attr.aria-label]="'Exit ' + businessName()"
        data-testid="business-exit"
        (click)="exit()"
    >
        <span
            class="flex h-[32px] w-[32px] shrink-0 items-center justify-center rounded-lg bg-[var(--p-amber-400)]/10 text-[var(--p-amber-400)]"
            aria-hidden="true"
        >
            <i class="pi pi-sign-out text-lg!"></i>
        </span>
        <span class="hidden min-w-0 max-w-36 flex-col items-start sm:flex">
            <span
                class="w-full truncate text-left text-[13px] leading-none font-semibold text-[var(--topbar-text)]"
            >
                {{ businessName() }}
            </span>
            <span class="mt-[3px] text-[12px] leading-none text-[var(--p-amber-400)]">Exit</span>
        </span>
    </button>
}
